import LampiranII from './LampiranII';

export default LampiranII